<div class="row border-bottom white-bg home-header">
    <div class="col-md-3">
        <h4>Dashboards</h4>
        <nav  class="navbar navbar-sticky d-none d-xl-block">
            <nav class="nav" *ngIf="dashboards != null">
                <a *ngFor="let d of dashboards;index as i" [routerLink]="'/dashboard/' + d.dashboardId" class="nav-link text-truncate" [ngClass]="{active:i==0}" data-toggle="scroll-to">{{d.name}}</a> 
            </nav>
            <nav class="nav" *ngIf="dashboards != null && dashboards.length == 0">
                <a [routerLink]="'/dashboards'" class="nav-link text-truncate" [ngClass]="{active:i==0}" data-toggle="scroll-to"><i class="fa fa-plus"></i>&nbsp;Add your first dashboard</a> 
            </nav>
            <nav class="nav" *ngIf="dashboards == null"  >
                <li><div class="spinner-border"></div></li>
            </nav>
        </nav>
    </div>
    <div class="col-md-6">
        <h3 class="h4">Welcome to {{configService.applicationName}}</h3>
        <div *ngIf="configService.homeScreen" [innerHtml]="configService.homeScreen"></div>
    </div>
    <div class="col-md-3">
        <h4>New Dashboards</h4>
        <nav class="navbar navbar-sticky d-none d-xl-block">
            <nav class="nav text-truncate" *ngIf="newDashboards != null">
                <a *ngFor="let d of newDashboards;index as i" [routerLink]="'/dashboard/' + d.dashboardId" class="nav-link" [ngClass]="{active:selected && selected.dashboardId == d.dashboardId}" data-toggle="scroll-to">{{d.name}}</a> 
            </nav>
            <nav class="nav text-truncate" *ngIf="newDashboards != null && newDashboards.length == 0">
                <a [routerLink]="'/dashboards'" class="nav-link" [ngClass]="{active:i==0}" data-toggle="scroll-to"><i class="fa fa-plus"></i>&nbsp;Nothing to see here!</a> 
            </nav>
            <nav class="nav" *ngIf="newDashboards == null">
                <li><div class="spinner-border"></div></li>
            </nav>
        </nav>
    </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
        <div class="col-lg-12" *ngIf="selected">
            <app-dashboard [dashboardId]="selected.dashboardId" [delayLoad]="false" [showEditor]="false"></app-dashboard>
        </div>
    </div>
</div>



<div class="modal fade" bsModal #newRelease="bs-modal" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" *ngIf="releaseNotes">
            <div class="modal-header">
                <h5 class="modal-title">NEW RELEASE: {{releaseNotes.version}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="newRelease.hide()"></button>
            </div>
            <div class="modal-body">
                <h1>This app has recently been updated.</h1>
                <p>Below are the release notes explaining any new features that might be of interest.</p>
                <div class="card">
                    <div class="card-body">
                        <div [innerHTML]="releaseNotes.notes"></div>
                    </div>                    
                </div>                
            </div>
            <div class="modal-footer">
                <button class="btn btn-outline-theme" (click)="ackRelease();newRelease.hide()">Acknowledge</button>
            </div>
        </div>
    </div>
</div>